import React, { useState } from 'react';
import {
  Header,
  Isotipo,
  Title
} from './styled';

import { Cover } from '@app/src/views/Login/Cover';

import { FormLoginContainer } from '../Login';
import { FormRecoverPasswordContainer } from '../RecoverPassword';

export const Form = ({
  urlLogin,
  urlRecoverPassword,
  history
}) => {
  const [ show, setShow ] = useState(false);
  const handleClick = () => {
    setShow(!show)
  }

  return (
    <Cover data-test="mainScreen">
      <Header>
        <Isotipo>
          <svg width="51" height="52" viewBox="0 0 144 96" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48 L48 0 L96 48 L48 96 Z" fill="#111" />
            <path d="M96 0 L144 48 L96 96 Z" fill="#111" />
          </svg>
        </Isotipo>
        <Title data-test="loginHeader">Callcenter PagoEfectivo</Title>
      </Header>
      {!show ? (
        <FormLoginContainer handleClick={handleClick} url={urlLogin} history={history} />
      ) : (
        <FormRecoverPasswordContainer handleClick={handleClick} url={urlRecoverPassword} />
      )
      }
    </Cover>
  );
}
